import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgOpenWissel = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#clip0_1614_22882)'>
      <path d='M3.563 15H2.5C2.224 15 2 14.776 2 14.5C2 14.224 2.224 14 2.5 14H3.563C3.839 14 4.063 14.224 4.063 14.5C4.063 14.776 3.839 15 3.563 15ZM8.063 14.5C8.063 14.224 7.839 14 7.563 14H6.5C6.224 14 6 14.224 6 14.5C6 14.776 6.224 15 6.5 15H7.563C7.839 15 8.063 14.776 8.063 14.5ZM12.063 14.5C12.063 14.224 11.839 14 11.563 14H10.5C10.224 14 10 14.224 10 14.5C10 14.776 10.224 15 10.5 15H11.563C11.839 15 12.063 14.776 12.063 14.5ZM18.825 11.169C18.629 10.976 18.312 10.978 18.118 11.175C17.925 11.372 17.927 11.689 18.124 11.882L20.278 14H15.687L7.687 7H2.5C2.224 7 2 7.224 2 7.5C2 7.776 2.224 8 2.5 8H7.312L15.312 15H20.306L18.167 17.174C17.974 17.37 17.976 17.688 18.173 17.881C18.271 17.977 18.397 18.025 18.524 18.025C18.653 18.025 18.783 17.975 18.88 17.876L22.206 14.495L18.824 11.17L18.825 11.169Z' />
    </g>
    <defs>
      <clipPath>
        <rect width={24} height={24} />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOpenWissel;
